export const MOBILE_APP_ROUTE = 'mobile-app';
